import { http, isExpired, HTTP_TOKEN, REJECT_MSG } from './http';
import { arrayStringToArrayInt } from '../utils';


export const fetchProductsByManufacturerId = (idFornecedor, page, recordPerPage) => {
    const config = {
        headers: { Authorization: `Bearer ${HTTP_TOKEN}` }
    }

    const options = {
        "Esquema": "web",
        "Tabela": "Produto",
        "Parametros": [
            {
                "Nome": "idFornecedor",
                "Valor": parseInt(idFornecedor)
            },
            {
                "Nome": "PaginaSQL",
                "Valor": parseInt(page)
            },
            {
                "Nome": "ResultadosPorPaginaSQL",
                "Valor": parseInt(recordPerPage)
            }
        ]
    }

    return new Promise((resolve, reject) => {
        const ret = http.post(`Dados/ObterDados`, options, config)

        if (isExpired(ret)) {
            reject(REJECT_MSG);
        }

        resolve(ret);
    })
}

export const fetchProductsSearch = (term, idFornecedor, hierarquia, idClassificacao, arrBrands, page, recordPerPage) => {
    const config = {
        headers: { Authorization: `Bearer ${HTTP_TOKEN}` }
    }
    const options = {
        "Esquema": "web",
        "Tabela": "Produto",
        "Parametros": [
            {
                "Nome": "PaginaSQL",
                "Valor": parseInt(page)
            },
            {
                "Nome": "ResultadosPorPaginaSQL",
                "Valor": parseInt(recordPerPage)
            }
        ]
    }

    if (idClassificacao) {
        options.Parametros.push({ "Nome": "idClassificacao", "Valor": null })
    }

    if (term) {
        options.Parametros.push({ "Nome": "Busca", "Valor": term })
    }

    if (idFornecedor) {
        options.Parametros.push({ "Nome": "idFornecedor", "Valor": arrayStringToArrayInt(idFornecedor) })
    }

    if (hierarquia) {
        options.Parametros.push({ "Nome": "HierarquiaProduto", "Valor": hierarquia })
    }

    if (arrBrands) {
        options.Parametros.push({ "Nome": "idClassificacaoMarca", "Valor": arrBrands })
    }

    return new Promise((resolve, reject) => {
        const ret = http.post(`Dados/ObterDados`, options, config)

        if (isExpired(ret)) {
            reject(REJECT_MSG);
        }

        resolve(ret);
    })
}


export const fetchSearchAutocomplete = (tokenLogin) => {
    const config = {
        headers: { Authorization: `Bearer ${tokenLogin ?? HTTP_TOKEN}` }
    }

    const options = {
        "Esquema": "web",
        "Tabela": "ObterProdutoBusca"
    }

    return new Promise((resolve, reject) => {
        const ret = http.post(`Dados/ObterDados`, options, config)

        if (isExpired(ret)) {
            reject(REJECT_MSG);
        }

        resolve(ret);
    })
}

export const fetchGarantia = () => {
    const config = {
        headers: { Authorization: `Bearer ${HTTP_TOKEN}` }
    }

    const options = {
        "Esquema": "web",
        "Tabela": "ProdutoGarantia"
    }

    return new Promise((resolve, reject) => {
        const ret = http.post(`Dados/ObterDados`, options, config)

        if (isExpired(ret)) {
            reject(REJECT_MSG);
        }

        resolve(ret);
    })
}



export const fetchProductsByCategoryId = (hierarchy, page, recordPerPage) => {
    const config = {
        headers: { Authorization: `Bearer ${HTTP_TOKEN}` }
    }

    const options = {
        "Esquema": "web",
        "Tabela": "Produto",
        "Parametros": [
            {
                "Nome": "HierarquiaProduto",
                "Valor": hierarchy
            },
            {
                "Nome": "PaginaSQL",
                "Valor": parseInt(page)
            },
            {
                "Nome": "ResultadosPorPaginaSQL",
                "Valor": parseInt(recordPerPage)
            }
        ]
    }

    return new Promise((resolve, reject) => {
        const ret = http.post(`Dados/ObterDados`, options, config)

        if (isExpired(ret)) {
            reject(REJECT_MSG);
        }

        resolve(ret);
    })
}


export const fetchProductsByTagHome = (value, total, tokenLogin = null) => {
    const config = {
        headers: { Authorization: `Bearer ${tokenLogin ?? HTTP_TOKEN}` }
    }

    var options;
    if (value === 'Promocao') {
        options = {
            "Esquema": "web",
            "Tabela": "Produto",
            "Parametros": [
                {
                    "Nome": "Tag",
                    "Valor": value
                },
                {
                    "Nome": "LimiteSQL",
                    "Valor": parseInt(total)
                },
                {
                    "Nome": "MaisRentavelPrimeiro",
                    "Valor": true
                },
                {
                    "Nome": "AgruparPorClassificacao",
                    "Valor": true
                },
                {
                    "Nome": "ProdutosMaisVendidos",
                    "Valor": true
                }
            ]
        }
    } else {
        options = {
            "Esquema": "web",
            "Tabela": "Produto",
            "Parametros": [
                {
                    "Nome": "Tag",
                    "Valor": value
                },
                {
                    "Nome": "LimiteSQL",
                    "Valor": parseInt(total)
                },
                {
                    "Nome": "MaisRentavelPrimeiro",
                    "Valor": true
                },
                {
                    "Nome": "AgruparPorClassificacao",
                    "Valor": true
                },
            ]
        }
    }

    return new Promise((resolve, reject) => {
        const ret = http.post(`Dados/ObterDados`, options, config);

        if (isExpired(ret)) {
            reject(REJECT_MSG);
        }

        resolve(ret);
    })
}


export const fetchProductsByTag = (nameHighlight, page, recordPerPage) => {
    const config = {
        headers: { Authorization: `Bearer ${HTTP_TOKEN}` }
    }

    const options = {
        "Esquema": "web",
        "Tabela": "Produto",
        "Parametros": [
            {
                "Nome": "Tag",
                "Valor": nameHighlight
            },
            {
                "Nome": "PaginaSQL",
                "Valor": parseInt(page)
            },
            {
                "Nome": "ResultadosPorPaginaSQL",
                "Valor": parseInt(recordPerPage)
            }
        ]
    }

    return new Promise((resolve, reject) => {
        const ret = http.post(`Dados/ObterDados`, options, config)

        if (isExpired(ret)) {
            reject(REJECT_MSG);
        }

        resolve(ret);
    })
}


export const fetchProductsById = (idProduto) => {
    const config = {
        headers: { Authorization: `Bearer ${HTTP_TOKEN}` }
    }
    const options = {
        "Esquema": "web",
        "Tabela": "Produto",
        "Parametros": [
            {
                "Nome": "idProduto",
                "Valor": parseInt(idProduto)
            }
        ]
    }

    return new Promise((resolve, reject) => {
        const ret = http.post(`Dados/ObterDados`, options, config)

        if (isExpired(ret)) {
            reject(REJECT_MSG);
        }

        resolve(ret);
    })
}


export const fetchProductsBySuggestion = (total) => {
    const config = {
        headers: { Authorization: `Bearer ${HTTP_TOKEN}` }
    }

    const options = {
        "Esquema": "web",
        "Tabela": "Produto",
        "Parametros": [
            {
                "Nome": "ProdutosMaisVendidos",
                "Valor": true
            },
            {
                "Nome": "LimiteSQL",
                "Valor": parseInt(total)
            },
            {
                "Nome": "ApenasRegistrosPedido",
                "Valor": true
            },
            {
                "Nome": "MaisRentavelPrimeiro",
                "Valor": true
            },
            {
                "Nome": "AgruparPorClassificacao",
                "Valor": true
            }
        ]
    }

    return new Promise((resolve, reject) => {
        const ret = http.post(`Dados/ObterDados`, options, config)

        if (isExpired(ret)) {
            reject(REJECT_MSG);
        }

        resolve(ret);
    })
}

export const fetchBanners = (idProduto = null) => {
    const config = {
        headers: { Authorization: `Bearer ${HTTP_TOKEN}` }
    }
    const options = {
        "Esquema": "web",
        "Tabela": "ImagensProduto",
        "Parametros": [
        ]
    }

    if (idProduto != null) {
        options.Parametros.push(
            {
                "Nome": "idProduto",
                "Valor": parseInt(idProduto)
            })
    }



    return new Promise((resolve, reject) => {
        const ret = http.post(`Dados/ObterDados`, options, config)

        if (isExpired(ret)) {
            reject(REJECT_MSG);
        }

        resolve(ret);
    })
}

export const fetchGeradorHMTL = (parametroControle) => {
    const config = {
        headers: { Authorization: `Bearer ${HTTP_TOKEN}` }
    }

    const options = {

        "idControle": "78",
        "parametroControle": parametroControle

    }

    return new Promise((resolve, reject) => {
        const ret = http.post(`Dados/GenerateHTML`, options, config);

        if (isExpired(ret)) {
            reject(REJECT_MSG);
        }

        resolve(ret);
    })
}

export const fetchTagVitrine = () => {
    const config = {
        headers: { Authorization: `Bearer ${HTTP_TOKEN}` }
    }
    const options = {
        "Esquema": "web",
        "Tabela": "TagVitrine",
    }



    return new Promise((resolve, reject) => {
        const ret = http.post(`Dados/ObterDados`, options, config)

        if (isExpired(ret)) {
            reject(REJECT_MSG);
        }

        resolve(ret);
    })
}

export const fetchProductsRelated = (idProduto = null) => {
    const config = {
        headers: { Authorization: `Bearer ${HTTP_TOKEN}` }
    }
    const options = {
        "Tabela": "ProdutosRelacionados",
        "Parametros": [

        ]
    }

    if (idProduto != null) {
        options.Parametros.push(
            {
                "Nome": "idProduto",
                "Valor": parseInt(idProduto)
            })
    }



    return new Promise((resolve, reject) => {
        const ret = http.post(`Dados/ObterDados`, options, config)

        if (isExpired(ret)) {
            reject(REJECT_MSG);
        }

        resolve(ret);
    })
}


export const fetchKitItems = (idProduto) => {
    const config = {
        headers: { Authorization: `Bearer ${HTTP_TOKEN}` }
    }
    const options = {
        "Esquema": "web",
        "Tabela": "Produto",
        "Parametros": [
            {
                "Nome": "PaginaSQL",
                "Valor": 0
            },
            {
                "Nome": "ResultadosPorPaginaSQL",
                "Valor": 20
            },
            {
                "Nome": "idProdutoKit",
                "Valor": idProduto
            }
        ]
    }



    return new Promise((resolve, reject) => {
        const ret = http.post(`Dados/ObterDados`, options, config)

        if (isExpired(ret)) {
            reject(REJECT_MSG);
        }

        resolve(ret);
    })
}

export const Registrar = (dados) => {
    const config = {
        headers: {
            Authorization: `Bearer ${HTTP_TOKEN}`
        }
    };
    
    const body = {
        Nome: dados.nome,
        Endereco: dados.endereco,
        Email: dados.email,
        idProduto: dados.idProduto,
        NumeroFatura: dados.numeroFatura,
        NumeroSerie: dados.numeroSerie,
        Modelo: dados.modelo,
        LojaCompra: dados.lojaCompra,
        DataCompra: dados.dataCompra
        
    };
console.log(body)
    return new Promise((resolve, reject) => {
        const ret = http.post(`Garantia/Registrar`, body, config);

        if (isExpired(ret)) {
            reject(REJECT_MSG);
            return;
        }

        resolve(ret);
    });
};